import { AuviousCommon, EventClientHandlers, Event, IEventClientSubscription, AuviousError } from '@auvious/common';
import { Observable, Subject } from 'rxjs';
import { Log } from '../services';
import { AVBusService } from '../services/bus.service';
import { HandledError } from './HandledError';
import { ErrorCode } from './enums';

export class EventClient {
    subscription: IEventClientSubscription;

    constructor(
        private auviousCommonClient: AuviousCommon
    ) { }

    public subscribeToTopic(topic: string) {
        this.auviousCommonClient.events.subscribe(topic);
    }

    public connect(): Observable<Event> {
        const observer: Subject<Event> = new Subject();
        const handlers: EventClientHandlers = {
            onMessageReceived: (event: Event) => {
                if (!event || !event.payload || event.payload.type === 'KeepAliveReminder') { return; }
                observer.next(event);
            },
            onError: (error: AuviousError) => {
                Log.error(error);
                AVBusService.errorLog(new HandledError(error, ErrorCode.EVENT_CLIENT_ERROR));
            },
            onConnectedFailed: (error: AuviousError) => {
                Log.error(error);
            }
        };
        try {
            this.connectToEventServer(handlers);
        } catch (ex) {
            observer.error(ex);
            Log.error(ex);
            AVBusService.errorLog(new HandledError(ex, ErrorCode.EVENT_CLIENT_ERROR));
        }
        return observer;
    }

    public disconnect(){
        this.subscription?.dispose();
    }

    private connectToEventServer(handlers: EventClientHandlers): void {
        if (!this.auviousCommonClient.eventsEnabled) {
            throw new Error('Internal error: events not enabled.');
        } else if (!this.auviousCommonClient.eventsInitialized) {
            throw new Error('Internal error: events not initialized.');
        }

        if (!!this.subscription) {
            this.subscription.dispose();
        }

        this.subscription = this.auviousCommonClient.events.setEventHandlers(handlers);
    }
}
